/* eslint-disable
    @typescript-eslint/no-unused-vars,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
// TODO: this doesn't actually work.
// Deriving a new error type is much more complicated than this.
let AssertionError;
module.exports = AssertionError = class AssertionError extends Error {};
